/**
 * ShopView
 *
 * The upgrade shop screen. Currently sells one item: rod level upgrades.
 * Extracted from App.js lines 825–908.
 *
 * Props:
 *   gold           {number}   - Current gold balance.
 *   level          {number}   - Current rod level.
 *   isProcessingBuy{boolean}  - Prevents double-clicks during Firebase write.
 *   onPurchaseLevel{function} - Called when the upgrade button is clicked.
 *   onBack         {function} - Navigates back to the menu.
 */

export default function ShopView({
  gold,
  level,
  isProcessingBuy,
  onPurchaseLevel,
  onBack,
}) {
  const getUpgradeCost = (currentLevel) => {
    return 100 + Math.pow(currentLevel, 2) * 10;
  };

  const cost = getUpgradeCost(level);
  const canAfford = gold >= cost;

  return (
    <div style={{ padding: '20px', maxWidth: '400px', margin: '0 auto', textAlign: 'center' }}>

      <h2 style={{ color: '#f3f4f6', marginBottom: '10px' }}>SHOP</h2>

      {/* Player Stats Header */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-around',
        backgroundColor: '#1f2937',
        padding: '10px',
        borderRadius: '8px',
        marginBottom: '30px',
        color: '#fbbf24',
        fontWeight: 'bold',
      }}>
        <span>Gold: {gold}</span>
        <span>Level: {level}</span>
      </div>

      {/* Shop Items */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>

        {/* Item: Fishing Rod Upgrade */}
        <div style={{
          backgroundColor: '#374151',
          padding: '20px',
          borderRadius: '8px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '10px',
        }}>
          <h3 style={{ margin: 0, color: '#f3f4f6' }}>Upgrade Rod</h3>
          <p style={{ margin: 0, fontSize: '12px', color: '#9ca3af' }}>
            Increase your fishing level to catch rarer fish!
          </p>

          <button
            onClick={onPurchaseLevel}
            disabled={!canAfford || isProcessingBuy}
            style={{
              marginTop: '10px',
              width: '100%',
              padding: '12px',
              backgroundColor: canAfford ? '#238636' : '#4b5563',
              color: canAfford ? 'white' : '#9ca3af',
              border: 'none',
              borderRadius: '6px',
              cursor: canAfford && !isProcessingBuy ? 'pointer' : 'not-allowed',
              fontWeight: 'bold',
              transition: 'background-color 0.2s',
              fontFamily: 'inherit',
            }}
          >
            {isProcessingBuy
              ? 'UPGRADING...'
              : canAfford
              ? `BUY LEVEL ${level + 1} (${cost} GOLD)`
              : `NEED ${cost} GOLD`
            }
          </button>
        </div>

        {/* Add future shop items here */}

      </div>

      {/* Back Button */}
      <button
        onClick={onBack}
        className="menu-btn"
        style={{
          marginTop: '30px',
          padding: '10px 20px',
          backgroundColor: 'transparent',
          color: '#8b949e',
          border: '1px solid #8b949e',
          borderRadius: '6px',
          cursor: 'pointer',
          fontFamily: 'inherit',
        }}
      >
        BACK TO MENU
      </button>

    </div>
  );
}